import {
  AttributeDataType,
  AttributeDefinition
} from "@wingspanhq/wingspan-api-sdk";
import { FieldBoolean } from "./FieldBoolean";
import { FieldDatetime } from "./FieldDatetime";
import { FieldEnum } from "./FieldEnum";
import { FieldNumber } from "./FieldNumber";
import { FieldString } from "./FieldString";
import { AcceptedValuesResources } from "./helpers";

type Props = {
  attributeDefinitions: AttributeDefinition[];
  resources: AcceptedValuesResources;
  disabled?: boolean;
};

export const FormPartialAttributes: React.FC<Props> = props => {
  return (
    <>
      {props.attributeDefinitions.map(definition => (
        <Field
          key={definition.key}
          definition={definition}
          resources={props.resources}
          disabled={props.disabled}
        />
      ))}
    </>
  );
};

const Field: React.FC<{
  definition: AttributeDefinition;
  resources: AcceptedValuesResources;
  disabled?: boolean;
}> = props => {
  switch (props.definition.type) {
    case AttributeDataType.BOOLEAN:
      return (
        <FieldBoolean definition={props.definition} disabled={props.disabled} />
      );
    case AttributeDataType.NUMBER:
      return (
        <FieldNumber definition={props.definition} disabled={props.disabled} />
      );
    case AttributeDataType.DATETIME:
      return (
        <FieldDatetime
          definition={props.definition}
          disabled={props.disabled}
        />
      );
    case AttributeDataType.VALUE_SET:
      return (
        <FieldEnum
          definition={props.definition}
          resources={props.resources}
          disabled={props.disabled}
        />
      );
    case AttributeDataType.STRING:
    default:
      return (
        <FieldString definition={props.definition} disabled={props.disabled} />
      );
  }
};
